import { render, staticRenderFns } from "./FiltersBar.vue?vue&type=template&id=1a72ac27"
import script from "./FiltersBar.vue?vue&type=script&lang=ts"
export * from "./FiltersBar.vue?vue&type=script&lang=ts"
import style0 from "./FiltersBar.vue?vue&type=style&index=0&id=1a72ac27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports